<script setup lang="ts">
import { DeliveryMethods } from '@/api/modules/basket/types'

type Props = {
  isShowPickupTab: boolean
  isShowHallTab: boolean
}
defineProps<Props>()

const model = defineModel<DeliveryMethods>()
</script>

<template>
  <the-tabs v-model="model" :is-single="!isShowPickupTab && !isShowHallTab">
    <the-tabs-item :value="DeliveryMethods.COURIER">Доставка</the-tabs-item>

    <the-tabs-item v-if="isShowPickupTab" :value="DeliveryMethods.PICKUP">
      Самовывоз
    </the-tabs-item>

    <the-tabs-item v-if="isShowHallTab" :value="DeliveryMethods.HALL">
      В ресторане
    </the-tabs-item>
  </the-tabs>
</template>
